module.exports = __webpack_public_path__ + "static/img/bg4.0e561c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg4.png
// module id = KMu3
// module chunks = 5